module.exports = __webpack_public_path__ + "img/Oiltanking_South-America_Brazil_Vitoria_Truckloading_2012-06-29_0942.04690cc8.jpg";